<app-top-navbar [hideFreeTrial]="true"></app-top-navbar>

<div class="signup-container">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <!-- Progress Bar -->
        <div class="registration-progress mb-5 mt-4">
          <div class="progress-steps d-flex justify-content-between">
            <div class="step" [class.active]="currentStep >= 1" [class.complete]="currentStep > 1">
              <div class="step-num">1</div>
              <div class="step-label">Account</div>
            </div>
            <div class="step-connector"></div>
            <div class="step" [class.active]="currentStep >= 2" [class.complete]="currentStep > 2">
              <div class="step-num">2</div>
              <div class="step-label">Company</div>
            </div>
            <div class="step-connector"></div>
            <div class="step" [class.active]="currentStep >= 3">
              <div class="step-num">3</div>
              <div class="step-label">Payment</div>
            </div>
          </div>
        </div>

        <div class="card shadow-lg border-0 bg-dark text-white">
          <div class="card-body p-2 p-md-2">
            <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
              <!-- STEP 1: ACCOUNT INFORMATION -->
              @if (currentStep === 1) {
              <div class="step-content animate-fade-in">
                <h3 class="fw-bold mb-1">Create your account</h3>
                <p class="text-muted mb-2">
                  Start your 14-day free trial. No credit card required today.
                </p>
                <div class="row g-2">
                  <!-- First Name -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">First Name</label>
                    <input type="text" formControlName="firstName" class="form-control form-control-dark"
                      [class.is-invalid]="signUpForm.get('firstName').touched && signUpForm.get('firstName').invalid"
                      placeholder="First Name" />
                    @if (
                    signUpForm.get('firstName').touched &&
                    signUpForm.get('firstName').invalid
                    ) {
                    <div class="invalid-feedback d-block">
                      First name is required
                    </div>
                    }
                  </div>
                  <!-- Last Name -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">Last Name</label>
                    <input type="text" formControlName="lastName" class="form-control form-control-dark"
                      [class.is-invalid]="signUpForm.get('lastName').touched && signUpForm.get('lastName').invalid"
                      placeholder="Last Name" />
                    @if (
                    signUpForm.get('lastName').touched &&
                    signUpForm.get('lastName').invalid
                    ) {
                    <div class="invalid-feedback d-block">
                      Last name is required
                    </div>
                    }
                  </div>
                  <!-- Username -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">Username</label>
                    <input type="text" formControlName="username" class="form-control form-control-dark"
                      placeholder="Auto-generated" readonly style="opacity: 0.7; cursor: default;" />
                  </div>
                  <!-- Email Address -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">Email Address</label>
                    <input type="email" formControlName="email" class="form-control form-control-dark"
                      [class.is-invalid]="signUpForm.get('email').touched && signUpForm.get('email').invalid"
                      placeholder="Email Address" />
                    @if (
                    signUpForm.get('email').touched &&
                    signUpForm.get('email').invalid
                    ) {
                    <div class="invalid-feedback d-block">
                      Please enter a valid email address
                    </div>
                    }
                  </div>
                  <!-- Password -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">Password</label>
                    <div class="input-group">
                      <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
                        class="form-control form-control-dark"
                        [class.is-invalid]="signUpForm.get('password').touched && signUpForm.get('password').invalid"
                        placeholder="••••••••" />
                      <button class="btn btn-outline-secondary" type="button" (click)="togglePassword()">
                        <i class="fas" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
                      </button>
                    </div>
                    @if (
                    signUpForm.get('password').touched &&
                    signUpForm.get('password').hasError('minlength')
                    ) {
                    <div class="invalid-feedback d-block">
                      Password must be at least 8 characters
                    </div>
                    }
                    @if (
                    signUpForm.get('password').touched &&
                    signUpForm.get('password').hasError('missingSpecialChar')
                    ) {
                    <div class="invalid-feedback d-block">
                      Password must contain at least one special character
                    </div>
                    }
                    @if (
                    signUpForm.get('password').touched &&
                    signUpForm.get('password').hasError('required')
                    ) {
                    <div class="invalid-feedback d-block">
                      Password is required
                    </div>
                    }
                  </div>
                  <!-- Confirm Password -->
                  <div class="col-12 col-md-6">
                    <label class="form-label text-light small fw-bold text-uppercase">Confirm Password</label>
                    <div class="input-group">
                      <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
                        class="form-control form-control-dark"
                        [class.is-invalid]="signUpForm.get('confirmPassword').touched && (signUpForm.get('confirmPassword').invalid || signUpForm.hasError('mismatch'))"
                        placeholder="••••••••" />
                      <button class="btn btn-outline-secondary" type="button" (click)="toggleConfirmPassword()">
                        <i class="fas" [class.fa-eye]="!showConfirmPassword"
                          [class.fa-eye-slash]="showConfirmPassword"></i>
                      </button>
                    </div>
                    @if (
                    signUpForm.get('confirmPassword').touched &&
                    signUpForm.hasError('mismatch')
                    ) {
                    <div class="invalid-feedback d-block">
                      Passwords do not match
                    </div>
                    }
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-4">
                  <button type="button" class="btn btn-primary px-5 py-2 fw-bold" (click)="nextStep()">
                    Next: Company Details
                    <i class="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
              }

              <!-- STEP 2: COMPANY INFORMATION -->
              @if (currentStep === 2) {
              <div class="step-content animate-fade-in">
                <h3 class="fw-bold mb-2">Tell us about your business</h3>
                <div class="business-form">
                  <!-- FFL, Expiration, EIN -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">FFL:</label>
                    <div class="col-sm-4">
                      <input type="text" formControlName="fflNumber"
                        class="form-control form-control-light text-uppercase" placeholder="X-XX-XXX-XX-X-XXXXX"
                        [dropSpecialCharacters]="false" mask="0-00-000-00-AA-00000" (input)="verifyFFL()" />
                    </div>
                    <label class="col-sm-1 col-form-label text-end fw-bold px-1">Exp:</label>
                    <div class="col-sm-2 px-1">
                      <input type="text" formControlName="fflExpiration" class="form-control form-control-light"
                        placeholder="MM/DD/YYYY" />
                    </div>
                    <label class="col-sm-1 col-form-label text-end fw-bold px-1">EIN:</label>
                    <div class="col-sm-2 ps-1">
                      <input type="text" formControlName="ein" class="form-control form-control-light"
                        placeholder="XX-XXXXXXX" mask="00-0000000" />
                    </div>
                  </div>
                  <!-- Company Info Row -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">Company Name:</label>
                    <div class="col-sm-4">
                      <input type="text" formControlName="companyName" class="form-control form-control-light"
                        placeholder="Company Name" />
                    </div>
                    <label class="col-sm-2 col-form-label text-end fw-bold">Legal Name:</label>
                    <div class="col-sm-4">
                      <input type="text" formControlName="legalName" class="form-control form-control-light"
                        placeholder="Legal Name" />
                    </div>
                  </div>

                  <!-- Address -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">Address:</label>
                    <div class="col-sm-10">
                      <input type="text" formControlName="address" class="form-control form-control-light"
                        placeholder="Street Address" />
                    </div>
                  </div>
                  <!-- Address 2 -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">Address 2:</label>
                    <div class="col-sm-10">
                      <input type="text" formControlName="address2" class="form-control form-control-light" />
                    </div>
                  </div>
                  <!-- City / State / Zip -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">City:</label>
                    <div class="col-sm-4">
                      <input type="text" formControlName="city" class="form-control form-control-light"
                        placeholder="City" />
                    </div>
                    <label class="col-sm-2 col-form-label text-end fw-bold">State:</label>
                    <div class="col-sm-1">
                      <input type="text" formControlName="state" class="form-control form-control-light uppercase-input"
                        placeholder="ID" maxlength="2" />
                    </div>
                    <label class="col-sm-1 col-form-label text-end fw-bold px-1">Zip:</label>
                    <div class="col-sm-2">
                      <input type="text" formControlName="zip" class="form-control form-control-light"
                        placeholder="ZIP Code" />
                    </div>
                  </div>
                  <!-- Phone & Email -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">Phone:</label>
                    <div class="col-sm-4">
                      <input type="text" formControlName="phoneNumber" class="form-control form-control-light"
                        placeholder="Phone Number" mask="(000) 000-0000" />
                    </div>
                    <label class="col-sm-2 col-form-label text-end fw-bold">Email:</label>
                    <div class="col-sm-4">
                      <input type="email" formControlName="companyEmail" class="form-control form-control-light"
                        placeholder="Email Address" />
                    </div>
                  </div>
                  <!-- Website -->
                  <div class="row align-items-center mb-1">
                    <label class="col-sm-2 col-form-label text-end fw-bold">Website:</label>
                    <div class="col-sm-10">
                      <input type="text" formControlName="companyWebsite" class="form-control form-control-light"
                        placeholder="Website URL" />
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-4">
                  <button type="button" class="btn btn-outline-light px-4 py-2" (click)="prevStep()">
                    <i class="fas fa-arrow-left me-2"></i> Back
                  </button>
                  <button type="button" class="btn btn-primary px-5 py-2 fw-bold" (click)="nextStep()">
                    Next: Payment Setup <i class="fas fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
              }

              <!-- STEP 3: PREMIUM PAYMENT SCREEN -->
              @if (currentStep === 3) {
              <div class="step-content animate-fade-in">
                <div class="checkout-layout">
                  <!-- Left: Summary -->
                  <aside class="checkout-summary">
                    <span class="checkout-badge">FFLXCEL</span>
                    <p class="summary-kicker">{{ checkoutTrial ? '30-day free trial' : 'Subscription' }}</p>
                    <h3>{{ selectedPlan }} Plan</h3>
                    <div class="summary-price">
                      <strong>{{ checkoutTrial ? '$0' : selectedPrice }}</strong>
                      <span>due today</span>
                    </div>
                    <div class="summary-row">
                      <span>After {{ checkoutTrial ? '30 days' : 'today' }}</span>
                      <b>{{ selectedPrice }} / month</b>
                    </div>
                    <ul class="checkout-assurances">
                      <li><span>✓</span> Cancel anytime</li>
                      <li><span>✓</span> No setup fees</li>
                      <li><span>✓</span> Secure, encrypted payment</li>
                    </ul>
                  </aside>

                  <!-- Right: Stripe Element Form -->
                  <form class="checkout-elements-form" (ngSubmit)="submitCheckout()">
                    <div class="payment-heading">
                      <div><small>PAYMENT DETAILS</small><h3>Complete checkout</h3></div>
                      <span class="test-badge">TEST MODE</span>
                    </div>
                    <label for="checkout-email">Email address</label>
                    <input id="checkout-email" name="checkoutEmail" type="email" autocomplete="email"
                      required [(ngModel)]="checkoutEmail" placeholder="you@example.com" />
                    <label>Card information</label>
                    <div id="embedded-checkout" class="embedded-checkout">
                      @if (!checkoutReady && !checkoutError) {
                        <div class="checkout-loading">
                          <span class="spinner-border spinner-border-sm me-2"></span> Loading secure payment…
                        </div>
                      }
                    </div>
                    @if (checkoutError) {
                      <p class="checkout-form-error" role="alert">{{ checkoutError }}</p>
                    }
                    <button class="btn checkout-submit" type="submit"
                      [disabled]="checkoutSubmitting || !checkoutEmail || !checkoutReady">
                      <span class="lock-icon" aria-hidden="true">&#128274;</span>
                      {{ checkoutSubmitting ? 'Processing securely…' : (checkoutTrial ? 'Start 30-day free trial' : 'Subscribe securely') }}
                    </button>
                    <div class="stripe-trust">
                      <span>Powered by <b>stripe</b></span><i></i>
                      <span>PCI DSS compliant</span><i></i>
                      <span>TLS encrypted</span>
                    </div>
                    <p class="checkout-legal">Your payment details are sent directly to Stripe and never touch FFLXCEL servers.</p>
                    <button type="button" class="btn btn-link text-muted w-100 mt-2 text-decoration-none small"
                      (click)="prevStep()">
                      <i class="fas fa-arrow-left me-1"></i> Back to company info
                    </button>
                  </form>
                </div>
              </div>
              }
            </form>
          </div>
        </div>

        <div class="text-center mt-4">
          <p class="text-light">
            Already have an account?
            <a routerLink="/login" class="text-primary text-decoration-none fw-bold">Sign In</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bottom-footer></app-bottom-footer>